import React from 'react';

const PlanDiscount = ({ label = '' }) => {
  if (!label) return null;
  // eslint-disable-next-line yola/react/no-danger
  return <div className="ws-ui-plan-discount" dangerouslySetInnerHTML={{ __html: label }} />;
};

export default PlanDiscount;
